import type { IApiCallbacks } from "../../redux/fetch";
import {
    extractErrorMessage,
    parseResponseBody,
} from "../../utils/httpResponse";

const handleSuccess = (json: unknown, callbacks?: IApiCallbacks) => {
    callbacks?.success?.(json);
    callbacks?.finally?.();
};

const handleError = (
    error: { response?: string; error?: string } | string,
    callbacks?: IApiCallbacks
) => {
    callbacks?.error?.(
        typeof error === "string"
            ? error
            : error.response || error.error || String(error)
    );
    callbacks?.finally?.();
};

const handleException = (exception: Error, callbacks?: IApiCallbacks) => {
    callbacks?.exception?.(exception);
    callbacks?.finally?.();
};

export const apiCall = (
    url: string,
    data?: unknown,
    callbacks?: IApiCallbacks,
    options: RequestInit = { method: "POST" }
) => {
    const requestOptions = {
        ...options,
        credentials: "same-origin" as RequestCredentials,
        headers: {
            ...(options.headers || {}),
        },
    };

    if (data) {
        requestOptions.body =
            data instanceof Object ? JSON.stringify(data) : String(data);
    }

    callbacks?.request?.();

    return fetch(url, requestOptions)
        .then(async (res) => {
            const payload = await parseResponseBody(res);
            if (!res.ok) {
                return handleError(
                    extractErrorMessage(payload) ||
                        res.statusText ||
                        `Request failed (${res.status})`,
                    callbacks
                );
            }

            return handleSuccess(payload, callbacks);
        })
        .catch((err) =>
            handleException(
                err instanceof Error ? err : new Error(String(err)),
                callbacks
            )
        );
};
